import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { UiFormModule } from "../../../shared/ui/ui-form.module";
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { RouterModule } from "@angular/router";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { CustomTableComponent } from "../../../shared/ui/custom-table/components/table/custom-table.component";


import { MatAutocompleteModule } from "@angular/material/autocomplete";

import { CreditListComponent } from "../credit/components/credit-list/credit-list.components";
import {CreditReducer} from './store/reducers/credit.reducer'
import {CreditService} from './services/credit.service'
import {CreditEffects} from './store/effects/credit.effects'
import { SharedModule } from "../../shared/shared.module";
import { CreditSharedModule } from "../credit-shared/credit-shared.module";




@NgModule({
  declarations:[
    CreditListComponent
  ],
  exports:[
    CreditListComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    UiFormModule,
    SharedModule,
    CreditSharedModule,
    RouterModule,
    FormsModule,

    // Angular Material
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    MatCardModule,
    MatDividerModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatSnackBarModule,

    // NgRx
    StoreModule.forFeature('credit', CreditReducer),
    EffectsModule.forFeature([CreditEffects])
  ],
  providers: [
    CreditService
  ]
})

export class CreditModule { }
